import { useEffect, useState } from "react";
import styles from "./list.module.css";
import DriverCard from "./DriverCard";
import { DriverJobsToolbar } from "./listview";

const MapView = ({ allData, setViewType, viewSwitch, filterVars, setFilterVars }) => {
    const [driverList, setDriverList] = useState([]);

    useEffect(() => {
        let driverListTemp = allData?.map(i => {
            return { id: i?.driver?.id, name: i?.driver?.name, address: i?.driver?.address, lat: i?.driver?.latitude, lng: i?.driver?.longitude };
        });

        driverListTemp = [...new Map(driverListTemp.map(item => [item.id, item])).values()];

        setDriverList(driverListTemp);
    }, [allData]);

    return (<>
        <DriverJobsToolbar data={allData} filterVars={filterVars} setFilterVars={setFilterVars} viewSwitch={viewSwitch} />

        <div>
            {driverList?.map(item => {
                return <DriverCard key={item?.id} driver={item} allData={allData} />
            })}

            {driverList?.length === 0 && (
                <div className={styles.EmptyState}>No drivers with assigned pickups yet</div>
            )}
        </div>
    </>);
};

export default MapView;
